import getWindow from "./getWindow.js";
export default function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}


//////////////////
// WEBPACK FOOTER
// ../@popperjs/core/lib/dom-utils/getWindowScroll.js
// module id = 410
// module chunks = 22